import React, { useMemo, useState } from "react";
import DatePicker from "react-datepicker";
import { object } from "prop-types";
import moment from "moment";

import "react-datepicker/dist/react-datepicker.css";
import "./datePicker.css";
import { Input } from "reactstrap";
import { DateIcon } from "../../assets";

const FormikDatePicker = ({ form, field, ...props }) => {
  const [selectedDate, setSelectedDate] = useState(
    field.value && new Date(field.value)
  );

  const handleChange = (date) => {
    form.setFieldValue(field.name, date == null ? null : moment(date).format());
    setSelectedDate(date);
  };

  const CustomInput = useMemo(() => {
    return React.forwardRef((props, ref) => {

      return (
        <div className="date-picker-box">
          <Input
            name="date"
            placeholder={props.placeholder}
            value={props.value}
            disabled={props.disabled}
            onClick={props.onClick}
            onChange={props.changeOnInput ? props.onChange : () => {}}
            ref={ref}
            style={selectedDate ? { backgroundColor: "#DBFFED" } : {}}
          />
          <div onClick={props.onClick} className="date-picker-icon-box">
            <DateIcon />
          </div>
        </div>
      );
    });
  });

  const datePickerContent = useMemo(() => {
    return (
      <DatePicker
        {...props}
        showYearDropdown
        scrollableYearDropdown
        yearDropdownItemNumber={props.yearDropdownItemNumber || 50}
        selected={selectedDate}
        onChange={handleChange}
        showIcon
        calendarClassName="rootCalendar"
        customInput={<CustomInput changeOnInput={props.changeOnInput} />}
        fixedHeight
        filterDate={(date) => {
          return moment() > date;
        }}
      />
    );
  }, [selectedDate, handleChange]);

  return datePickerContent;
};

FormikDatePicker.propTypes = {
  props: object,
  field: object.isRequired,
  form: object.isRequired,
};

export default FormikDatePicker;



// WEBPACK FOOTER //
// ./src/components/formik/DatePicker.jsx